import { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

import Map from './map-page/Map'
import OverlayControl from './overlay-control/OverlayControl'

import NoteStore from './stores/NoteStore'

import QueryContext from './context/QueryContext';
import MapContext from './context/MapContext'
import NotesContext from './context/NotesContext'

import getInitialMapContextValues from './configuration/getInitialMapContextValues'
import watchCurrentLocation from './geolocation/watchCurrentLocation'

import {
  getParcelDetailByXY,
  getParcelMultipleLayersByXY,
  getSchoolDistrictsByXY,
  getZoningByXY ,
} from './api/server-api'


const Container = styled.div`
  height: 100%;
  width: 100%;
  font: normal 100% helvetica, arial, sans-serif;
  color: #000;
  background-color: #EFE5C1;
`

const initialMapContextValues = getInitialMapContextValues();

export default function App() {
  // location data for MapContext
  const [ currentLocation, setCurrentLocation ] = useState(null);
  const [ queryLocation, setQueryLocation ] = useState(null);

  // parcel data for QueryContext
  const [ queryData, setQueryData ] = useState(null);
  const [ queryType, setQueryType ] = useState('single-parcel');
  //const [ queryType, setQueryType ] = useState('school-districts');
  const [ searchParams, setSearchParams ] = useState(null);

  // note data for NotesContext
  const [ notes, setNotes ] = useState({});
  const [ noteStore, setNoteStore ] = useState(null);

  // click handler for Map queries
  const queryClickHandler = useCallback(   // to reduce <Map> rerendering
    async (clickCoordinates, mapResolution) => {
      //console.warn('** queryClickHandler **');
      //console.log(clickCoordinates);
      setQueryData(null);
      const { markers, showResultOnMap } = initialMapContextValues;
      markers.clear();
      markers.add('xx', clickCoordinates);
      setQueryLocation(clickCoordinates);
      // TODO: do xy query and show results
      //   this is where queryData is gotten for query click
      let data;
      switch (queryType) {
        case 'single-parcel':
          data = await getParcelDetailByXY(clickCoordinates, mapResolution);
          showResultOnMap(data, false, false);
          break;
        case 'multiple-layers':
          data = await getParcelMultipleLayersByXY(clickCoordinates, mapResolution);
          showResultOnMap(data, false, false);
          break;
        case 'zoning':
          data = await getZoningByXY(clickCoordinates, mapResolution);
          break;
        case 'school-districts':
          data = await getSchoolDistrictsByXY(clickCoordinates, mapResolution);
          break;
        default:
      }
      /*
      if (!data) {
        data = {
          markerLocation: clickCoordinates
        }
      } else if (!data.markerLocation) {
        data.markerLocation = clickCoordinates;
      }
      */
      //console.error('got data ******');
      //console.log(data);
      // TODO: this currently changed location from click to parcel location
      setQueryData(data);
    }, [queryType]);

  // get notes from local storage
  useEffect(() => {
    //console.error('** App.useEffect - setting up note store');
    const store = new NoteStore('mapclick-mobile2');
    const notes = store.retrieveAllNotes();
    if (notes) {
      setNotes(notes);
    }
    setNoteStore(store);
  },[])

  // setup watch to keep track of GPS location
  useEffect(() => {
    const newLocationHandler = (record) => {
      const { userLocations } = initialMapContextValues;
      //console.error('App.newLocationHandler ******');
      if (record) {
        // TODO: move location marker to new location
        const point = [record.x, record.y];
        userLocations.clear();
        userLocations.add('current-location', point);
        setCurrentLocation(record);
      }
    }

    //console.error('** App.useEffect - setting up location watch ****');
    // TODO: does this need cleaning up?
    const id = watchCurrentLocation(newLocationHandler);
  },[]);

  //console.error('rendering App ***********');
  //console.log(currentLocation);

  const mapContextValues = { ...initialMapContextValues, currentLocation, queryLocation };
  const queryContextValues = {queryType, queryLocation, setQueryLocation, queryData, setQueryType, setQueryData, searchParams, setSearchParams};
  const notesContextValues = { notes, setNotes, noteStore };

  // note: <Map> and <Overlay> are "position: absolute" filling container
  return (
    <MapContext.Provider value={mapContextValues}>
    <QueryContext.Provider value={queryContextValues}>
    <NotesContext.Provider value={notesContextValues}>
      <Container>
        <Map onQueryClick={queryClickHandler} />
        <OverlayControl/>
      </Container>
    </NotesContext.Provider>
    </QueryContext.Provider>
    </MapContext.Provider>
  );

}
